export const DATA_FIRESTORE_V01_EVENT_TICKETING = {
  NAME: 'v01_event_ticketing',
  FIELDS: {
    SPECTATOR_TICKETS: {
      KEY: 'spectator ticket',
    },
  },
}
